import React from "react";
import Heading from "../../components/heading/Heading";
export default (function () {
    return React.createElement("div", null,
        React.createElement(Heading, { level: "4" }, "Payments"));
});
